import { Component, OnInit, NgZone, ViewChild, ChangeDetectorRef } from '@angular/core';
import { LocalStorageService } from '../../services/local-storage.service';
import { PlayerService } from '../../services/player.service';
import { Router } from '@angular/router';
import { FLIP_X_ANIMATION, FLIP_Y_ANIMATION } from '../../animations/flip.animation';
import { BOUNCE_IN_UP } from '../../animations/bounce.animation';
import { FLIP_IN_X, FLIP_IN_Y } from '../../animations/flip-in.animation';
import { FADE_IN_RIGHT_BIG, FADE_IN_LEFT_BIG } from '../../animations/fade-in.animation';
import { MatDialog } from '@angular/material/dialog';
import { PlayVideoDialogComponent } from '../play-video-dialog/play-video-dialog.component';
import { CreateAccountComponent } from '../create-account/create-account.component';
import { ScrollToService } from '../../services/scroll-to.service';
import { Player } from '../../objects/player';
import { Group } from '../../objects/group';
import { GroupService } from '../../services/group.service';
import { isValidEmail } from '../../shared/validators/email.validator';
import { isValidUsPhone, normalizeUsPhone } from '../../shared/validators/phone.validator';
import "hammerjs";

//import { ScrollToConfigOptions } from '@nicky-lenaers/ngx-scroll-to/src/app/modules/scroll-to/models/scroll-to-config.model';

@Component({
  selector: 's18-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
  animations: [FLIP_X_ANIMATION, BOUNCE_IN_UP, FLIP_IN_X, FLIP_IN_Y, FADE_IN_RIGHT_BIG, FADE_IN_LEFT_BIG]
})
export class HomeComponent implements OnInit {

  flipped: boolean = false;
  flipCompleted: boolean = true;
  showPricing: boolean = false;
  showTestimonials: boolean = false;
  flipAndWatchVideo: boolean = false;
  interval: any;

  fName: string;
  lName: string;
  email: string;
  phone: string;
  registerError: string;
  currentSlide = 0;
  slides = [0, 1, 2];
  slideLeft = false;

  constructor(
    private scrollToService: ScrollToService,
    private playerService: PlayerService,
    private groupService: GroupService,
    private router: Router,
    private localStorage: LocalStorageService,
    private dialog: MatDialog,
    zone: NgZone) {
    window.onscroll = () => {
      zone.run(() => {
        if (window.pageYOffset > 3000 && !this.showPricing) {
          this.showPricing = true;
        }
      })
    };

    this.resetInterval();
  }

  resetInterval() {
    clearInterval(this.interval);
    this.slideLeft = false;
    this.interval = setInterval(() => {
      this.nextSlide();
    }, 5000)
  }

  nextSlide() {
    this.resetInterval();
    this.currentSlide++;
    if (this.currentSlide > 2) {
      this.currentSlide = 0;
    }
  }


  previousSlide() {
    this.resetInterval();
    this.slideLeft = true;
    this.currentSlide--;
    if (this.currentSlide < 0) {
      this.currentSlide = 2;
    }
  }

  goToSlide(slide) {
    this.resetInterval();
    if (this.currentSlide > slide) {
      this.slideLeft = true;
    }
    this.currentSlide = slide;
  }

  fadeRight(item) {
    if (this.currentSlide == item && !this.slideLeft) {
      return 'on';
    }
    if (this.slideLeft) {
      return 'off_left';
    }
    return 'off';
  }

  fadeLeft(item) {
    if (this.currentSlide == item && this.slideLeft) {
      return 'on';
    }
    if (!this.slideLeft) {
      return 'off_right';
    }
    return 'off'
  }

  register() {
    // WI 58: require a valid email AND a valid phone before creating the player.
    if (!isValidEmail(this.email) || !isValidUsPhone(this.phone)) {
      this.registerError = "Enter a valid email and a valid 10-digit US phone number.";
      return;
    }
    this.registerError = "";
    this.playerService.registerWithEmail(this.email, this.fName, this.lName, "0", this.lName, normalizeUsPhone(this.phone))
      .subscribe(resp => {
        this.login();
      });
  }

  login() {
    this.playerService.login(this.email, this.lName)
      .subscribe(resp => {
        var player: Player = JSON.parse(resp.d)[0];
        this.playerService.setLoggedInPlayerInfo(player);
        this.getAdminGroups(player);
      });
  }

  ngOnDestroy() {
    clearInterval(this.interval);
  }

  getAdminGroups(player) {
    this.playerService.getAdminGroups(player.player_id.toString())
      .subscribe(resp => {
        var adminGroups: Group[] = JSON.parse(resp.d).groups;
        this.groupService.setAdminGroups(adminGroups);
        this.router.navigateByUrl("/dashboard");
      });
  }

  joinNow() {
    var dialogRef = this.dialog.open(CreateAccountComponent, { width: "500px" });
  }

  isFlipped() {
    if (this.flipped) {
      return 'on';
    }
    return 'off';
  }
  ngOnInit() {
    this.localStorage.set('hideHeader', false);
    this.localStorage.set('hideFooter', false);

    var player = this.playerService.getLoggedInPlayerInfo();
    if (player) {
      this.router.navigateByUrl('dashboard');
    }
  }

  animationCompleted() {

  }

  showText() {
    return this.flipCompleted;
  }

  bounceIn() {
    if (this.showText()) {
      return 'on'
    }
    return 'off';
  }



  watchVideo() {
    var dialogRef = this.dialog.open(PlayVideoDialogComponent, { panelClass: 'move-up' });

    dialogRef.afterClosed().subscribe(() => {
      //this.scrollToService.scrollTo({target: '#product-calculator'});
    });
  }

  scrollToId(id) {
    var target = "#" + id;
    this.scrollToService.scrollTo({ target: target });
  }



}
